// import { useState } from "react";

// function GstSearch() {
//     const [gstin, setGstin] = useState("");
//     const [data, setData] = useState(null);

//     const fetchGSTDetails = async () => {
//         const response = await fetch("http://localhost:5000/get-gstin-details", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ gstin })
//         });

//         const result = await response.json();
//         setData(result);
//     };

//     return (
//         <div>
//             <input type="text" placeholder="Enter GSTIN" value={gstin} onChange={(e) => setGstin(e.target.value)} />
//             <button onClick={fetchGSTDetails}>Search</button>

//             {data && <pre>{JSON.stringify(data, null, 2)}</pre>}
//         </div>
//     );
// }

// export default GstSearch;



import React, { useState, useEffect } from "react";
import PopupForm from "./PopupForm.js"; // Import the Popup Form
import "./GstReconciliation.css";

const services = [
  {
    title: "Enhance Your GST Reconciliation Process",
    description:
      "We provide hassle-free and advanced GST reconciliation solutions to reduce compliance burden. Our system ensures **100% ITC claims** by identifying and matching entries accurately.",
  },
  {
    title: "Challenges in GST Reconciliation",
    description:
      "GST reconciliation faces common issues like GSTIN mismatches, invoice errors, timing differences, rounding off variations, and unfiled returns. Our system detects and resolves these challenges.",
  },
  {
    title: "Our Automated Solution",
    description:
      "Our AI-powered system auto-identifies mismatched data, integrates with ERP systems, handles high-volume invoices efficiently, and corrects supplier-side errors.",
  },
  {
    title: "Real-Time Invoice Matching",
    description:
      "Automatically match invoices across multiple return periods to ensure compliance. Identify discrepancies before filing returns and avoid penalties.",
  },
  {
    title: "Final Reconciliation Reports",
    description:
      "Our system generates categorized reports: **Matched, Not in GSTR-2A, Not in Purchase Register, and Mismatched**, ensuring a smooth reconciliation process.",
  }
];

const GSTReconciliation = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Function to open the PDF in a new tab
  const openPDF = () => {
    window.open("/GST Advance Reco - DataBoltaHi.pdf", "_blank");
  };

  // Function to go to the next service
  const nextService = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
  };

  // Function to go to the previous service
  const prevService = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? services.length - 1 : prevIndex - 1
    );
  };

  // Auto-change services every 5 seconds unless hovered
  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        nextService();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isHovered]);

  return (
    <div className="gst-reconciliation-container">
      {/* Hero Section */}
      <section className="hero-gst-section">
        <div className="hero-content">
          <h1>GST Reconciliation</h1>
          <p>
            Automate and simplify GST return filings and reconciliation processes.
          </p>
          <div className="hero-buttons-wrapper">
            <button className="connect-now-btn" onClick={() => setIsPopupOpen(true)}>
              Connect Now!
            </button>
            <button className="open-pdf-btn" onClick={openPDF}>
              View PDF
            </button>
          </div>
        </div>
      </section>

      {/* About GST Reconciliation */}
      <section className="about-gst-section">
        <div className="about-content">
          <div className="vector-image">
            <img src="./gst-img.png" alt="GST Reconciliation" />
          </div>

          <div className="about-text">
            <h2>What is GST Reconciliation?</h2>
            <p>
              GST reconciliation is the process of matching the data filed by your suppliers 
              with your purchase records to ensure accurate tax filings and avoid penalties.
            </p>
            <ul>
              <li>🔹 Automated Data Matching</li>
              <li>🔹 GST Compliance Reports</li>
              <li>🔹 Minimize Errors & Penalties</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <h2 className="section-title">Why Choose Our GST Reconciliation Solution?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">📄</span>
            <h3>Automated Filing</h3>
            <p>Seamless GST return filing with automation.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">✅</span>
            <h3>Accurate Matching</h3>
            <p>Match invoices and tax data with high precision.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">⏳</span>
            <h3>Save Time</h3>
            <p>Reduce errors and manual work with smart processing.</p>
          </div>
        </div>
      </section>

      {/* New Bottom Section - Carousel */}
      <section className="gst-carousel-section">
        <h2>Transform Your GST Reconciliation</h2>
        <div 
          className="gst-service-carousel" 
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="gst-service-card">
            <h3>{services[currentIndex].title}</h3>
            <p>{services[currentIndex].description}</p>
            <div className="carousel-controls">
              <button onClick={prevService}>&#9665;</button> {/* Left arrow */}
              <button onClick={nextService}>&#9655;</button> {/* Right arrow */}
            </div>
          </div>
        </div>
      </section>

      {/* Popup Form Component */}
      <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default GSTReconciliation;
